export const payoutConversionOptions = ["Qualified Deposit", "Registration"]
export const countryOptions = [
  { id: "A1", label: "A1 - Anonymous Proxy" },
  { id: "A2", label: "A2 - Satellite Provider" },
  { id: "AD", label: "AD - Andorra" },
  { id: "AE", label: "AE - United Arab Emirates" },
  { id: "AF", label: "AF - Afghanistan" },
  { id: "AG", label: "AG - Antigua and Barbuda" },
  { id: "AI", label: "AI - Anguilla" },
  { id: "AL", label: "AL - Albania" },
  { id: "AM", label: "AM - Armenia" },
  { id: "AO", label: "AO - Angola" },
  { id: "AP", label: "AP - Asia/Pacific Region" },
  { id: "AQ", label: "AQ - Antarctica" },
  { id: "AR", label: "AR - Argentina" },
  { id: "AS", label: "AS - American Samoa" },
  { id: "AT", label: "AT - Austria" },
  { id: "AU", label: "AU - Australia" },
  { id: "AW", label: "AW - Aruba" },
  { id: "AX", label: "AX - Åland Islands" },
  { id: "AZ", label: "AZ - Azerbaijan" },
  { id: "BA", label: "BA - Bosnia and Herzegovina" },
  { id: "BB", label: "BB - Barbados" },
  { id: "BD", label: "BD - Bangladesh" },
  { id: "BE", label: "BE - Belgium" },
  { id: "BF", label: "BF - Burkina Faso" },
  { id: "BG", label: "BG - Bulgaria" },
  { id: "BH", label: "BH - Bahrain" },
  { id: "BI", label: "BI - Burundi" },
  { id: "BJ", label: "BJ - Benin" },
  { id: "BL", label: "BL - Saint Barthélemy" },
  { id: "BM", label: "BM - Bermuda" },
  { id: "BN", label: "BN - Brunei Darussalam" },
  { id: "BO", label: "BO - Bolivia" },
  { id: "BQ", label: "BQ - Bonaire, Sint Eustatius and Saba" },
  { id: "BR", label: "BR - Brazil" },
  { id: "BS", label: "BS - Bahamas" },
  { id: "BT", label: "BT - Bhutan" },
  { id: "BV", label: "BV - Bouvet Island" },
  { id: "BW", label: "BW - Botswana" },
  { id: "BY", label: "BY - Belarus" },
  { id: "BZ", label: "BZ - Belize" },
  { id: "CA", label: "CA - Canada" },
  { id: "CC", label: "CC - Cocos (Keeling) Islands" },
  { id: "CD", label: "CD - Congo (Democratic Republic of the)" },
  { id: "CF", label: "CF - Central African Republic" },
  { id: "CG", label: "CG - Congo" },
  { id: "CH", label: "CH - Switzerland" },
  { id: "CI", label: "CI - Côte d'Ivoire" },
  { id: "CK", label: "CK - Cook Islands" },
  { id: "CL", label: "CL - Chile" },
  { id: "CM", label: "CM - Cameroon" },
  { id: "CN", label: "CN - China" },
  { id: "CO", label: "CO - Colombia" },
  { id: "CR", label: "CR - Costa Rica" },
  { id: "CU", label: "CU - Cuba" },
  { id: "CV", label: "CV - Cabo Verde" },
  { id: "CW", label: "CW - Curaçao" },
  { id: "CX", label: "CX - Christmas Island" },
  { id: "CY", label: "CY - Cyprus" },
  { id: "CZ", label: "CZ - Czechia" },
  { id: "DE", label: "DE - Germany" },
  { id: "DJ", label: "DJ - Djibouti" },
  { id: "DK", label: "DK - Denmark" },
  { id: "DM", label: "DM - Dominica" },
  { id: "DO", label: "DO - Dominican Republic" },
  { id: "DZ", label: "DZ - Algeria" },
  { id: "EC", label: "EC - Ecuador" },
  { id: "EE", label: "EE - Estonia" },
  { id: "EG", label: "EG - Egypt" },
  { id: "EH", label: "EH - Western Sahara" },
  { id: "ER", label: "ER - Eritrea" },
  { id: "ES", label: "ES - Spain" },
  { id: "ET", label: "ET - Ethiopia" },
  { id: "EU", label: "EU - European Union" },
  { id: "FI", label: "FI - Finland" },
  { id: "FJ", label: "FJ - Fiji" },
  { id: "FK", label: "FK - Falkland Islands" },
  { id: "FM", label: "FM - Micronesia" },
  { id: "FO", label: "FO - Faroe Islands" },
  { id: "FR", label: "FR - France" },
  { id: "GA", label: "GA - Gabon" },
  { id: "GB", label: "GB - United Kingdom" },
  { id: "GD", label: "GD - Grenada" },
  { id: "GE", label: "GE - Georgia" },
  { id: "GF", label: "GF - French Guiana" },
  { id: "GG", label: "GG - Guernsey" },
  { id: "GH", label: "GH - Ghana" },
  { id: "GI", label: "GI - Gibraltar" },
  { id: "GL", label: "GL - Greenland" },
  { id: "GM", label: "GM - Gambia" },
  { id: "GN", label: "GN - Guinea" },
  { id: "GP", label: "GP - Guadeloupe" },
  { id: "GQ", label: "GQ - Equatorial Guinea" },
  { id: "GR", label: "GR - Greece" },
  { id: "GS", label: "GS - South Georgia and the South Sandwich Islands" },
  { id: "GT", label: "GT - Guatemala" },
  { id: "GU", label: "GU - Guam" },
  { id: "GW", label: "GW - Guinea-Bissau" },
  { id: "GY", label: "GY - Guyana" },
  { id: "HK", label: "HK - Hong Kong" },
  { id: "HM", label: "HM - Heard Island and McDonald Islands" },
  { id: "HN", label: "HN - Honduras" },
  { id: "HR", label: "HR - Croatia" },
  { id: "HT", label: "HT - Haiti" },
  { id: "HU", label: "HU - Hungary" },
  { id: "ID", label: "ID - Indonesia" },
  { id: "IE", label: "IE - Ireland" },
  { id: "IL", label: "IL - Israel" },
  { id: "IM", label: "IM - Isle of Man" },
  { id: "IN", label: "IN - India" },
  { id: "IO", label: "IO - British Indian Ocean Territory" },
  { id: "IQ", label: "IQ - Iraq" },
  { id: "IR", label: "IR - Iran" },
  { id: "IS", label: "IS - Iceland" },
  { id: "IT", label: "IT - Italy" },
  { id: "JE", label: "JE - Jersey" },
  { id: "JM", label: "JM - Jamaica" },
  { id: "JO", label: "JO - Jordan" },
  { id: "JP", label: "JP - Japan" },
  { id: "KE", label: "KE - Kenya" },
  { id: "KG", label: "KG - Kyrgyzstan" },
  { id: "KH", label: "KH - Cambodia" },
  { id: "KI", label: "KI - Kiribati" },
  { id: "KM", label: "KM - Comoros" },
  { id: "KN", label: "KN - Saint Kitts and Nevis" },
  { id: "KP", label: "KP - North Korea" },
  { id: "KR", label: "KR - South Korea" },
  { id: "KW", label: "KW - Kuwait" },
  { id: "KY", label: "KY - Cayman Islands" },
  { id: "KZ", label: "KZ - Kazakhstan" },
  { id: "LA", label: "LA - Laos" },
  { id: "LB", label: "LB - Lebanon" },
  { id: "LC", label: "LC - Saint Lucia" },
  { id: "LI", label: "LI - Liechtenstein" },
  { id: "LK", label: "LK - Sri Lanka" },
  { id: "LR", label: "LR - Liberia" },
  { id: "LS", label: "LS - Lesotho" },
  { id: "LT", label: "LT - Lithuania" },
  { id: "LU", label: "LU - Luxembourg" },
  { id: "LV", label: "LV - Latvia" },
  { id: "LY", label: "LY - Libya" },
  { id: "MA", label: "MA - Morocco" },
  { id: "MC", label: "MC - Monaco" },
  { id: "MD", label: "MD - Moldova" },
  { id: "ME", label: "ME - Montenegro" },
  { id: "MF", label: "MF - Saint Martin" },
  { id: "MG", label: "MG - Madagascar" },
  { id: "MH", label: "MH - Marshall Islands" },
  { id: "MK", label: "MK - North Macedonia" },
  { id: "ML", label: "ML - Mali" },
  { id: "MM", label: "MM - Myanmar" },
  { id: "MN", label: "MN - Mongolia" },
  { id: "MO", label: "MO - Macau" },
  { id: "MP", label: "MP - Northern Mariana Islands" },
  { id: "MQ", label: "MQ - Martinique" },
  { id: "MR", label: "MR - Mauritania" },
  { id: "MS", label: "MS - Montserrat" },
  { id: "MT", label: "MT - Malta" },
  { id: "MU", label: "MU - Mauritius" },
  { id: "MV", label: "MV - Maldives" },
  { id: "MW", label: "MW - Malawi" },
  { id: "MX", label: "MX - Mexico" },
  { id: "MY", label: "MY - Malaysia" },
  { id: "MZ", label: "MZ - Mozambique" },
  { id: "NA", label: "NA - Namibia" },
  { id: "NC", label: "NC - New Caledonia" },
  { id: "NE", label: "NE - Niger" },
  { id: "NF", label: "NF - Norfolk Island" },
  { id: "NG", label: "NG - Nigeria" },
  { id: "NI", label: "NI - Nicaragua" },
  { id: "NL", label: "NL - Netherlands" },
  { id: "NO", label: "NO - Norway" },
  { id: "NP", label: "NP - Nepal" },
  { id: "NR", label: "NR - Nauru" },
  { id: "NU", label: "NU - Niue" },
  { id: "NZ", label: "NZ - New Zealand" },
  { id: "OM", label: "OM - Oman" },
  { id: "PA", label: "PA - Panama" },
  { id: "PE", label: "PE - Peru" },
  { id: "PF", label: "PF - French Polynesia" },
  { id: "PG", label: "PG - Papua New Guinea" },
  { id: "PH", label: "PH - Philippines" },
  { id: "PK", label: "PK - Pakistan" },
  { id: "PL", label: "PL - Poland" },
  { id: "PM", label: "PM - Saint Pierre and Miquelon" },
  { id: "PN", label: "PN - Pitcairn Islands" },
  { id: "PR", label: "PR - Puerto Rico" },
  { id: "PT", label: "PT - Portugal" },
  { id: "PW", label: "PW - Palau" },
  { id: "PY", label: "PY - Paraguay" },
  { id: "QA", label: "QA - Qatar" },
  { id: "RE", label: "RE - Réunion" },
  { id: "RO", label: "RO - Romania" },
  { id: "RS", label: "RS - Serbia" },
  { id: "RU", label: "RU - Russia" },
  { id: "RW", label: "RW - Rwanda" },
  { id: "SA", label: "SA - Saudi Arabia" },
  { id: "SB", label: "SB - Solomon Islands" },
  { id: "SC", label: "SC - Seychelles" },
  { id: "SD", label: "SD - Sudan" },
  { id: "SE", label: "SE - Sweden" },
  { id: "SG", label: "SG - Singapore" },
  { id: "SH", label: "SH - Saint Helena" },
  { id: "SI", label: "SI - Slovenia" },
  { id: "SJ", label: "SJ - Svalbard and Jan Mayen" },
  { id: "SK", label: "SK - Slovakia" },
  { id: "SL", label: "SL - Sierra Leone" },
  { id: "SM", label: "SM - San Marino" },
  { id: "SN", label: "SN - Senegal" },
  { id: "SO", label: "SO - Somalia" },
  { id: "SR", label: "SR - Suriname" },
  { id: "SS", label: "SS - South Sudan" },
  { id: "ST", label: "ST - São Tomé and Príncipe" },
  { id: "SV", label: "SV - El Salvador" },
  { id: "SX", label: "SX - Sint Maarten" },
  { id: "SY", label: "SY - Syria" },
  { id: "SZ", label: "SZ - Eswatini" },
  { id: "TC", label: "TC - Turks and Caicos Islands" },
  { id: "TD", label: "TD - Chad" },
  { id: "TF", label: "TF - French Southern Territories" },
  { id: "TG", label: "TG - Togo" },
  { id: "TH", label: "TH - Thailand" },
  { id: "TJ", label: "TJ - Tajikistan" },
  { id: "TK", label: "TK - Tokelau" },
  { id: "TL", label: "TL - Timor-Leste" },
  { id: "TM", label: "TM - Turkmenistan" },
  { id: "TN", label: "TN - Tunisia" },
  { id: "TO", label: "TO - Tonga" },
  { id: "TR", label: "TR - Turkey" },
  { id: "TT", label: "TT - Trinidad and Tobago" },
  { id: "TV", label: "TV - Tuvalu" },
  { id: "TZ", label: "TZ - Tanzania" },
  { id: "UA", label: "UA - Ukraine" },
  { id: "UG", label: "UG - Uganda" },
  { id: "US", label: "US - United States" },
  { id: "UY", label: "UY - Uruguay" },
  { id: "UZ", label: "UZ - Uzbekistan" },
  { id: "VA", label: "VA - Vatican City" },
  { id: "VC", label: "VC - Saint Vincent and the Grenadines" },
  { id: "VE", label: "VE - Venezuela" },
  { id: "VG", label: "VG - Virgin Islands" },
  { id: "VI", label: "VI - U.S. Virgin Islands" },
  { id: "VN", label: "VN - Vietnam" },
  { id: "VU", label: "VU - Vanuatu" },
  { id: "WF", label: "WF - Wallis and Futuna" },
  { id: "WS", label: "WS - Samoa" },
  { id: "YE", label: "YE - Yemen" },
  { id: "YT", label: "YT - Mayotte" },
  { id: "ZA", label: "ZA - South Africa" },
  { id: "ZM", label: "ZM - Zambia" },
  { id: "ZW", label: "ZW - Zimbabwe" },
]
